import { useMemo } from 'react';
import { useGetUserCountByState } from '@practium/features/api';

export interface RegionData {
	name: string;
	value: number;
	percentage: number;
	color: string;
}

const COLORS = ['#689ee6', '#8B9FE8', '#A89FEA', '#B982C9', '#648CB3'];

export const useRegionPieChart = () => {
	const south = useGetUserCountByState('PR,RS,SC');
	const north = useGetUserCountByState('AC,AP,AM,PA,RO,RR,TO');
	const southeast = useGetUserCountByState('ES,MG,RJ,SP');
	const midwest = useGetUserCountByState('DF,GO,MT,MS');
	const northeast = useGetUserCountByState('AL,BA,CE,MA,PB,PE,PI,RN,SE');

	const chartData = useMemo((): RegionData[] => {
		const regions = [
			{ name: 'Sul', value: south.data?.totalUsers ?? 0 },
			{ name: 'Norte', value: north.data?.totalUsers ?? 0 },
			{ name: 'Sudeste', value: southeast.data?.totalUsers ?? 0 },
			{ name: 'Centro-Oeste', value: midwest.data?.totalUsers ?? 0 },
			{ name: 'Nordeste', value: northeast.data?.totalUsers ?? 0 },
		];
		const total = regions.reduce((sum, region) => sum + region.value, 0);

		return regions
			.filter((region) => region.value > 0)
			.sort((a, b) => b.value - a.value)
			.map((region, index) => ({
				...region,
				percentage: total > 0 ? Math.round((region.value / total) * 100) : 0,
				color: COLORS[index],
			}));
	}, [south.data, north.data, southeast.data, midwest.data, northeast.data]);

	return {
		chartData,
		isLoading:
			south.isPending || north.isPending || southeast.isPending || midwest.isPending || northeast.isPending,
		isError: south.isError || north.isError || southeast.isError || midwest.isError || northeast.isError,
	};
};
